export default __webpack_public_path__ + "static/media/wrong-answer-129254.a800d8f6.mp3";